export default __webpack_public_path__ + "static/media/screen1.3994bf61.png";